<template>
    <DialogLayout>
        <h3 class="ModalAccount__title">Connectez-vous à votre compte</h3>
        <form class="FormMaterial ModalAccount__form" @submit.prevent="handleSubmit">
            <div v-if="error" class="Alert Alert--error m-b-15">
                {{error}}
                <button v-if="resendVerificationTo" :disabled="sending" type="button"
                        @click.prevent="resendVerification">
                    Renvoyer l'email de vérification
                </button>
            </div>
            <InputMaterial label="Adresse e-mail" v-model="data.email" type="email"/>
            <InputMaterial label="Mot de passe" v-model="data.password" type="password"/>
            <div class="ModalAccount__actions">
                <div class="Checkbox">
                    <input class="Checkbox__input" type="checkbox" id="remember-me" v-model="data.isRemember">
                    <label class="Checkbox__label" for="remember-me">Se souvenir de moi</label>
                </div>
                <button type="button" class="ModalAccount__forgotten" @click.prevent="forgotten">
                    Mot de passe oublié ?
                </button>
            </div>
            <div class="text-center">
                <button :disabled="loading" type="submit" class="Btn Btn--primary Btn--gradient Btn--shadow">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span v-else>Se connecter <i class="fas fa-caret-right m-l-5"></i></span>
                </button>
                <button v-if="isMobile" type="button" @click.prevent="$emit('changeTab', 'signup')"
                        class="ModalAccount__switch">
                    Je n'ai pas de compte
                </button>
            </div>
        </form>
    </DialogLayout>
</template>

<script>
    import axios from 'axios';
    import ModalBus from "../../../eventBus";
    import ForgottenModal from "./ForgottenModal";
    import DialogLayout from "../Layouts/DialogLayout";
    import InputMaterial from "../../InputMaterial";
    import Api from "../../../services/Api";

    export default {
        components: {InputMaterial, DialogLayout},
        props: ['isMobile'],
        data: function () {
            return {
                data: {
                    email: null,
                    password: null,
                    isRemember: false
                },
                resendVerificationTo: null,
                loading: false,
                sending: false,
                error: null
            }
        },
        methods: {
            forgotten: function () {
                ModalBus.open({component: ForgottenModal});
            },
            resendVerification: async function () {
                try {
                    await Api.post('/auth/email/resend', {
                        email: this.resendVerificationTo
                    });

                    ModalBus.alertSuccess(
                        'Email envoyé !',
                        'Afin de vérifier votre compte, un email contenant un lien de vérification vous a été envoyé. Pensez à vérifier vos spams.'
                    );
                } catch (err) {
                    ModalBus.processingError();
                }
            },
            handleSubmit: async function () {
                let {email, password, isRemember} = this.data;
                this.resendVerificationTo = null;

                if (!email || !password) {
                    this.error = 'Veuillez saisir vos identifiants.';
                    return;
                }

                this.loading = true;

                try {
                    const {data} = await axios.post('/login', {
                        email,
                        password,
                        remember_me: isRemember
                    });

                    window.location.href = data.redirectTo;
                } catch (err) {
                    if (err.response?.data?.error) {
                        let data = err.response.data;
                        this.loading = false;

                        if (data.code === 'NOT_VERIFIED') {
                            this.error = 'Veuillez vérifier votre compte en suivant le lien qui vous a été envoyé lors de l\'inscription.'
                            this.resendVerificationTo = email;
                        }else{
                            this.error = 'Identifiants incorrects.';
                        }
                    } else {
                        ModalBus.processingError();
                    }
                }
            }
        }
    }
</script>
